export default "__VITE_ASSET__B23TMvFv__"